import Form from './Form';
import barba from '@barba/core';
const ENDPOINT = '/wp-json/api/v1/application';
class ApplicationForm extends Form {
    constructor(form) {
        super(form);
        this.addEventListeners();
    }
    addEventListeners() {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.form.addEventListener('change', this.handleFileChange.bind(this));
    }
    handleFileChange() {
        const fileInput = this.form.querySelector('#file');
        const files = fileInput.files;
        if (files.length > 2)
            fileInput.setCustomValidity('invalid');
        else
            fileInput.setCustomValidity('');
    }
    handleSubmit(event) {
        event.preventDefault();
        const files = [...this.form.querySelector('#file').files];
        this.formatInputData();
        const data = new FormData();
        data.append('first_name', this.formdata.first_name);
        data.append('last_name', this.formdata.last_name);
        data.append('email', this.formdata.email);
        data.append('tel', this.formdata.tel);
        data.append('message', this.formdata.message);
        data.append('role', document.querySelector('h1').innerText);
        data.append('type', this.form.dataset.applicationType);
        data.append('page', window.location.href);
        data.append('privacy_policy', this.formdata.privacy_policy);
        files.forEach((file) => data.append('file[]', file));
        const button = this.form.querySelector('.submit');
        if (this.validate()) {
            this.form.classList.remove('was-validated');
            this.formatInputData();
            button.disabled = true;
            button.classList.add('btn_loading');
            fetch(ENDPOINT, {
                method: 'POST',
                body: data,
            })
                .then((responseData) => responseData.json())
                .catch((error) => console.error(error))
                .finally(() => {
                button.classList.remove('btn_loading');
                button.classList.add('btn_success');
                setTimeout(() => {
                    button.disabled = false;
                    this.form.reset();
                }, 1000);
                setTimeout(() => {
                    button.classList.remove('btn_success');
                }, 1000);
                if (document.documentElement.lang === 'en-GB') {
                    barba.go('/thank-you');
                }
                else {
                    barba.go('/sv/tack-sida');
                }
            });
        }
    }
}
export const initApplicationForms = () => document
    .querySelectorAll('.oim-application-form')
    .forEach((form) => new ApplicationForm(form));
